import type { ClientSessionResponse } from '@astrologermatch/shared';

// The anonymous client session for pay-per-click (ADR-004): a signed id the server issues with
// each search. Kept in sessionStorage (this tab only, gone when it closes) — never a cookie, and
// never anything about the chat itself (CLAUDE.md rule 8). Storage can be unavailable (private
// mode, blocked site data); search and clicks still work, each search then starts a new session.
const KEY = 'am_client_session';

export function readClientSession(): string | undefined {
  try {
    return window.sessionStorage.getItem(KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function saveClientSession(r: ClientSessionResponse): void {
  try {
    if (r.clientSession) window.sessionStorage.setItem(KEY, r.clientSession);
  } catch {
    // storage blocked: nothing to do
  }
}
